<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useI18n } from "vue-i18n"

import type { BreadcrumbItem } from "@core/components/layout/header/HeaderPage.vue"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            breadcrumbAccueil: "Accueil",
            pageTitle: "Analyse de la température ambiante des bâtiments",
        },
    },
})

// ================================
// DONNÉES CALCULÉES
// ================================
/**
 * Fil d'Ariane (Accueil → titre de la page).
 */
const getBreadcrumb = computed<BreadcrumbItem[]>(() => [
    {
        icon: "pi pi-home",
        label: t("breadcrumbAccueil"),
        route: "/",
    },
    { icon: "pi pi-chart-line", label: t("pageTitle") },
])
</script>

<template>
    <div class="page page-dashboard-iot flex min-h-0 flex-1 flex-col gap-8 p-6">
        <!-- ================================ -->
        <!-- HEADER PAGE -->
        <!-- ================================ -->
        <HeaderPage :title="t('pageTitle')" :breadcrumb="getBreadcrumb" />

        <!-- ================================ -->
        <!-- HEADER DASHBOARD IoT -->
        <!-- ================================ -->
        <DashboardIotHeader />
    </div>
</template>
